import {Box, Stack} from '@mui/material'
import {lazy, memo} from 'react'
import {useMatch} from 'react-router'
import {Loader} from '../../../../components/Loader'
import {UserSelector} from '../UserSelector'
import {AppBarSpot} from './AppBarSpot'

const AppBarSearchWrapper = lazy(async () => ({default: (await import('./AppBarSearch/AppBarSearchWrapper')).AppBarSearchWrapper}))

const AppBarItemsSpot = memo(() => {
  return <>
    <Stack
      direction="row"
      sx={{
        justifyContent: 'start',
        alignItems: 'center',
        overflow: 'hidden',
      }}>
      <AppBarSpot/>
    </Stack>

    <Loader fallback={<Box sx={{flex: 1}}/>}>
      <AppBarSearchWrapper/>
    </Loader>

    <UserSelector/>
  </>
})

const AppBarItemsDefault = memo(() => {
  return <>
    <Stack
      direction="row"
      sx={{
        justifyContent: 'start',
        alignItems: 'center',
        overflow: 'hidden',
        flexGrow: 1,
      }}>
      <AppBarSpot/>
    </Stack>

    <UserSelector/>
  </>
})

export const AppBarItems = memo(() => {
  const match = !!useMatch('/:lang/spot/:spotSlug/routes/*')

  if (match) {
    return <AppBarItemsSpot/>
  }

  return <AppBarItemsDefault/>
})
